import { IPageInfo } from './common.interface';

export enum SortOrder {
    ASC = 'ASC',
    DESC = 'DESC',
}

export const PAGE_SIZE = 10;
export const MAX_AGE_LIMIT = 100;

export const defaultPageInfo: IPageInfo = {
    currentPage: 1,
    pageSize: PAGE_SIZE,
    sortField: 'id',
    sortOrder: SortOrder.ASC,
};

export enum Gender {
    MALE = 'male',
    FEMALE = 'female',
}

export enum API_STATUS_CODES {
    OK = 200,
    CREATED = 201,
    ACCEPTED = 202,
    NO_CONTENT = 204,

    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    CONFLICT = 409,
    UNPROCESSABLE_ENTITY = 422,

    INTERNAL_SERVER_ERROR = 500,
    NOT_IMPLEMENTED = 501,
    BAD_GATEWAY = 502,
    SERVICE_UNAVAILABLE = 503,
    GATEWAY_TIMEOUT = 504,
}
